import { render, staticRenderFns } from "./AnnouncementsItem.vue?vue&type=template&id=6f6a33da&scoped=true&"
import script from "./AnnouncementsItem.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementsItem.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementsItem.vue?vue&type=style&index=0&id=6f6a33da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a33da",
  null
  
)

export default component.exports